import React from "react";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "../../Components/Common/DashboardHeader";

interface LegalPageLayoutProps {
  title?: string;
  children: React.ReactNode;
}

const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({ title, children }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="auth-container">
      <DashboardHeader />
      <div className="legal-page-content">
        <div className="legal-page-card">
          {title ? <h1 className="legal-page-title">{title}</h1> : null}
          <div className="legal-page-body">{children}</div>
          <div className="legal-close-footer">
            <button
              type="button"
              className="legal-close-btn"
              onClick={handleClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalPageLayout;
